import {Vacature} from '../../models/vacature';
import {Component, Input} from '@angular/core';
import {VacatureDetailComponent} from '../vacature-detail/vacature-detail.component';


@Component({
  selector: 'mvw-vacature-info',
  templateUrl: './vacature-info.component.html',
  imports: [VacatureDetailComponent]
})
export class VacatureInfoComponent {

  @Input() vacatures!: Vacature[];

}
